function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
import FilesService from '@/apps/data-platform/services/security/files_service';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import tasks from '@/js/tasks';
export default {
  name: 'DatasourceDsTabGeneral',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    valid: {
      type: Object,
      default: function _default() {
        return {
          organization: true,
          database_engine: true,
          data_operator: true,
          kdomain: true,
          ksubdomain: true,
          table: true,
          object_description: true,
          response_text: true
        };
      }
    },
    isNotDatasourceDs: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread({
    filterSubDomain: function filterSubDomain() {
      var _this = this;
      var selectbSubdomain = this.selectSubdomain.filter(function (Subdomain) {
        return Subdomain.domain.includes(_this.item.kdomain);
      });
      return selectbSubdomain;
    },
    showButtonAttachment: function showButtonAttachment() {
      var userInfo = window.userInfo;
      var dataOperator = this.item.data_operator;
      var userRoles = userInfo.userRoles || [];
      return userRoles.includes(ROLES_LIST.ORG_DATA_STEWARD) || dataOperator === userInfo.email;
    }
  }, mapState('data-platform', ['selectDomain', 'selectSubdomain', 'organizations'])),
  watch: {
    item: function item(newVal, oldVal) {
      this.environ_initial = newVal['environment'];
      this.files = newVal.files || [];
    }
  },
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      inputUploadFile: null,
      domain_table: '',
      files: [],
      currentFile: {},
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      validform: true,
      requiredFlag: null
    };
  },
  created: function created() {
    this.domain_table = window.userInfo.domain;
    this.environ_initial = this.item['environment'];
    this.files = this.item.files || [];
    if (this.selectDomain.length == 0) {
      this.$store.dispatch('data-platform/getBusinessDomainQuery');
    }
    this.requiredFlag = this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA || this.item.environment === ENVIRONMENT_FLOW.PROD;
    console.log("flag: ", this.requiredFlag);
  },
  methods: {
    getDatasourceName: function getDatasourceName(ds) {
      var name = "";
      if (ds.connectionDetails && ds.connectionDetails.kind) {
        name = ds.connectionDetails.kind;
      } else {
        name = ds.datasourceType;
      }
      return name;
    },
    onDownloadCsv: function onDownloadCsv() {
      var tplMeta = this.item;
      var columns = ['field_name', 'business_definition', 'masked', 'sensitive_data'];
      var header = ['organization', 'object_name', 'kdomain', 'ksubdomain', 'data_operator', 'environment', 'path_name', 'sensitive_data', 'object_descripcion'];
      header = header.concat(columns);
      header = header.join(';');
      var body = [];
      body.push(header);
      var data = [tplMeta.organization, tplMeta.object_name, tplMeta.kdomain, tplMeta.ksubdomain, tplMeta.data_operator, tplMeta.environment, tplMeta.path_name, tplMeta.sensitive_data ? 'true' : 'false', tplMeta.object_description];
      /*
      tplMeta.columns.forEach((item) => {
        const row = [...data]
        for (let i = 0; i < columns.length; i++) {
          row.push(item[columns[i]])
        }
        body.push(row.join(';'))
      })*/
      var row = [].concat(data);
      body.push(row.join(';'));
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var url = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + body.join('\n'));
      a.href = url;
      a.download = "Dataset-".concat(tplMeta.path_name, "_").concat(tplMeta.object_name, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onFileChange: function onFileChange(event) {
      var _this2 = this;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: "".concat(_this2.item.luid, "/files/").concat(file.name),
          type: BUCKET_DIRECTORY_TYPES.DATASETS,
          domain_source: _this2.domain_table
        };
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              domainTable: _this2.domain_table,
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            _this2.files.push(_file);
            _this2.updateFiles();
            _this2.inputUploadFile = null;
          } else {
            _this2.inputUploadFile = null;
            tasks.toast.error(res['message']);
            //this.$toast.warning(res['message'])
          }
        });
      };
      fileReader.readAsDataURL(file);
    },
    updateFiles: function updateFiles() {
      this.item['files'] = this.files;
      var dataset = {
        domain: window.userInfo.domain,
        dataset: this.item
      };
      BiDatasetService.datasetAddUpdate(dataset).then(function (res) {
        if (res.success && res.code === 200) {
          if (!res.success) {
            tasks.toast.error(response.message);
            //alert(res.message)
          }
        }
      });
    },
    deleteFile: function deleteFile(record) {
      var _this3 = this;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          var files = _this3.files;
          _this3.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this3.updateFiles();
        }).then(function () {
          _this3.currentFile = {};
        });
      }
    },
    onClickLink: function onClickLink(file) {
      var _this4 = this;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this4.isLoading = false;
        if (response.success) {
          _this4.image = response.data.base64;
          _this4.dataImage = response.data;
          _this4.filename = response.data.name.split('/').pop();
          _this4.contentType = response.data.contentType;
          _this4.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
          _this4.$bvModal.show('preview-file');
        } else {
          _this4.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          //alert(response.message)
        }
      });
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    copyLinkDatasource: function copyLinkDatasource(ds) {
      navigator.clipboard.writeText(ds.connectionDetails.url);
      //this.$toast.info("Access link copied!")
    }
  }
};